/** Версия юртекстов (соглашение + политика). Менять при существенных правках документов. */
export const LEGAL_TERMS_VERSION = "2026-03-30";
